<template>
  <b-modal
    hasModalCard
    :customClass="modalCardClasses"
    :active="isOpen"
    :width="width"
    :canCancel="canCancel"
    @close="$emit('onClose')"
  >
    <div class="card academy-custom-card">
      <div class="card-content">
        <div>
          <slot name="modal-card-content"></slot>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import cn from 'classnames'
export default {
  name: 'AcademyModal',
  props: {
    isOpen: {
      type: Boolean,
      default() {
        return false
      },
    },
    modalCardClass: {
      type: String,
      default() {
        return ''
      },
    },
    width: {
      type: [Number, String],
      default() {
        return 960
      },
    },
    canCancel: {
      type: [Boolean, Array],
      default() {
        return false
      },
    },
  },
  computed: {
    modalCardClasses() {
      return cn('academy-modal-card', this.modalCardClass)
    },
  },
}
</script>

<style lang="scss">
.academy-modal-card {
  .modal-background {
    display: block;
  }

  .academy-custom-card {
    min-width: 540px;
    overflow: auto;
    max-height: 90vh;
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
    border: solid 1px #ebebeb;
    background-color: #f8f8f8;

    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #cccccc;
    }
  }
}
</style>
